import { put, call, takeEvery } from 'redux-saga/effects';
import * as postponedActionsActions from './postponedActionsActions';

export function* dispatchPostponedActions({ payload: postponedActions }) {
  for (let index = 0; index < postponedActions.size; ++index) {
    const postponedAction = postponedActions.get(index);
    const { action } = postponedAction;
    if (action.meta && action.meta.attemptsLeft !== undefined) {
      action.meta.attemptsLeft = postponedAction.action.meta.attemptsLeft - 1;
    }
    if (!action.meta || action.meta.attemptsLeft === undefined || action.meta.attemptsLeft) {
      yield put(action);
    } else if (postponedAction.onFailure) {
      yield call(postponedAction.onFailure);
    }
  }
}

export function* dispatchPostponedActionsActionWatcher() {
  yield takeEvery(postponedActionsActions.dispatchPostponedActions, dispatchPostponedActions);
}

export function* dismissPostponedActions({ payload: postponedActions }) {
  if (postponedActions) {
    for (let index = 0; index < postponedActions.size; ++index) {
      const postponedAction = postponedActions.get(index);
      if (postponedAction.onFailure) {
        yield call(postponedAction.onFailure);
      }
    }
  }
}

export function* dismissPostponedActionsActionWatcher() {
  yield takeEvery(postponedActionsActions.dismissPostponedActions, dismissPostponedActions);
}

export default [
  dispatchPostponedActionsActionWatcher,
  dismissPostponedActionsActionWatcher,
];
